export type PublicDocsNavigationItem = {
	title: string
	href: string
}

export type PublicDocsNavigationGroup = {
	title: string
	items: PublicDocsNavigationItem[]
}

function matchesHref(pathname: string, href: string) {
	return pathname === href || pathname.startsWith(`${href}/`)
}

export function getBestMatchingPublicDocItem(
	pathname: string,
	groups: PublicDocsNavigationGroup[],
): PublicDocsNavigationItem | undefined {
	let bestMatch: PublicDocsNavigationItem | undefined

	for (const group of groups) {
		for (const item of group.items) {
			if (!matchesHref(pathname, item.href)) continue
			if (!bestMatch || item.href.length > bestMatch.href.length) {
				bestMatch = item
			}
		}
	}

	return bestMatch
}

export function getBestMatchingPublicDocGroup(
	pathname: string,
	groups: PublicDocsNavigationGroup[],
): PublicDocsNavigationGroup | undefined {
	const bestMatch = getBestMatchingPublicDocItem(pathname, groups)
	if (!bestMatch) return undefined
	return groups.find((group) =>
		group.items.some((item) => item.href === bestMatch.href),
	)
}
